import ClientsList from '../jsons/clients.json'

const clientsImages = require.context('../images/logo-clients', true );

const OurClients = () => {
  return (
    <section className='ourClientsWrapper'>
      <div className='containerFull'>
        <h3>Trusted by companies with real software operations</h3>
        <div className='title-underline blue-green-orange'></div>
        <p className='ourClients-subtitle'>From marketplaces and healthcare platforms to ecommerce, staffing, and internal business systems.</p>
      </div> 

      <div className='clients-list-wrapper'>
        <div className='clients-list-track'>
          {
            ClientsList.map((client) => (
              <div key={ client.id }>
                <img 
                  src={clientsImages(`./${client.file}`)}
                  alt={client.name}
                />
              </div>
            ))
          }
        </div>
      </div>

    </section>
  );
}

export default OurClients;